export default "__VITE_ASSET__DXZzumvQ__"